import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import Router from "./config/RouterConfig";
import { useDispatch, useSelector } from "react-redux";
import { initializeApp } from "./features/auth/authSlice";
import PageSpinner from "./components/PageSpinner/PageSpinner";

const App = () => {
  const dispatch = useDispatch();
  const { isAppReady } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(initializeApp());
  }, [dispatch]);

  if (!isAppReady) return <PageSpinner fullPage size="large" />;

  return (
    // <Suspense fallback={<PageSpinner size="large" fullPage={true} />}>
    <BrowserRouter>
      <Router />
    </BrowserRouter>
    // </Suspense>
  );
};

export default App;
